export default __webpack_public_path__ + "static/podolog-ilona-olszewska-71c8c398d26d2473b18f62f64c54cc58.jpg";